import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CookiesAllowedState } from '@modules/allowed-cookies/store/cookies-allowed/cookies-allowed.reducer';
import { CookiesState } from '@modules/allowed-cookies/store';

export const selectCookiesAllowedState = createFeatureSelector<CookiesState>('cookies-allowed');

export const selectCookiesAllowedEntity = createSelector(
  selectCookiesAllowedState,
  (state: CookiesState) => state?.cookiesAllowed
);

export const selectCookiesAllowed = createSelector(
  selectCookiesAllowedEntity,
  (state: CookiesAllowedState): boolean => {
    return state?.entity?.isAllowedCookies;
  }
);

export const selectCookiesPoliceModalVisible = createSelector(
  selectCookiesAllowedEntity,
  (state: CookiesAllowedState) => {
    return state?.entity?.isCookiesPolicyModalVisible;
  }
);
